import React from 'react';
import { Text, Space } from '@cashfree-intl/coherent';
import { PLACEHOLDER_TEXT } from 'utils/constants';
import { StyledChip, StyledEndpointText, StyledRetryMessage, StyledSpace, StyledSummaryPaper } from '../styled';
import { getRetryMessage } from '../helpers';
import CustomIcons from 'components/CustomIcons';

const Summary = ({ policyListData, endpointDetails, checkedItems }) => {
    return (
        <>
            <Text variant="h16" strong>
                Summary
            </Text>
            <Space gap={2.2} className="mt-2">
                <StyledEndpointText variant='b14' color="bodyLight" >Endpoint URL </StyledEndpointText>
                <Text strong> {endpointDetails?.channelValue || PLACEHOLDER_TEXT}</Text>
            </Space>
            <Space gap={6} className="mt-1">
                <Text color="bodyLight">Select Webhook Version </Text>
                <Text strong> {endpointDetails?.cfApiVersion || PLACEHOLDER_TEXT}</Text>
            </Space>
            {policyListData?.map((policyData, index) => {
                return (<StyledSummaryPaper className="accordion-policy-timeline mt-2" >
                    <Text variant="h16" strong>
                        Policy {index + 1}  {checkedItems[index].length <= 0 && <StyledChip as='span' variant='b14'>User Action Pending</StyledChip>}
                    </Text>
                    <Space gap={3} className=" mt-2">
                        <Text color="bodyLight">Retry Policy :</Text>
                        <Text strong> {policyData?.retryType}</Text>
                    </Space>
                    <StyledSpace gap={7} className="mt-1">
                        <Text color="bodyLight">Events :</Text>
                        {checkedItems[index].length ? <Text strong> {checkedItems[index].join(',')}</Text> : <Text variant="b14" color="warning" >
                           <CustomIcons componentName='PENDING'/> No Events Added
                        </Text>}
                    </StyledSpace>
                    <StyledRetryMessage variant='b14'>
                        {getRetryMessage(policyData)}
                    </StyledRetryMessage>
                </StyledSummaryPaper>)
            })

            }
        </>
    );
};

export default Summary;
